const state = () => ({
    mobipassStandby: false,
    sourceUrl: null,
})

const getters = {
    getMobipassStandby: (state) => {
        return state.mobipassStandby
    },

    getSourceUrl: (state) => {
        return state.sourceUrl
    },
}

const actions = {
    setMobipassStandby({ commit }, data) {
        commit("SET_MOBIPASS_STANDBY", data)
    },

    resetMobipassStandby({ commit }) {
        commit("RESET_MOBIPASS_STANDBY")
    },

    setSourceUrl({ commit }, url) {
        commit("SET_SOURCE_URL", url)
    },
}

const mutations = {
    SET_MOBIPASS_STANDBY(state, data) {
        const expirationDurationInMinutes = 15
        data.timeExpiration =
            Date.now() + expirationDurationInMinutes * 60 * 1000

        state.mobipassStandby = data
    },

    RESET_MOBIPASS_STANDBY(state) {
        state.mobipassStandby = false
    },

    SET_SOURCE_URL(state, data) {
        state.sourceUrl = data
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
